import React, { useState } from "react";
import Loader from "../../Loader";
import Table from "../TableContactPage/table";
export default function ContactDashboard() {
  const [isLoading, setIsLoading] = useState(true);
  const [contact, setContact] = useState(null);
  // const inputRef = useRef(null);

  useState(() => {
    async function getData() {
      const response = await fetch(
        `${process.env.REACT_APP_server}/contact`
      );
      let contact = await response.json();
      setContact(contact);
      // console.log(contact);
      setIsLoading(false);
    }
    getData();
  }, []);

  const column = [
    { heading: "Name", value: "name" },
    { heading: "Email", value: "email" },
    { heading: "Subject", value: "subject" },
    { heading: "Message", value: "message" },
    { heading: "Date", value: "date" },
  ];

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div>
          {" "}
          <div className="h1-contact">
            <h1>Dynamic Table</h1>
          </div>
          <Table data={contact} column={column} />
        </div>
      )}
    </>
  );
}
